
































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import WebhookItem from "./Item.vue";
import { BrazeWebhookDto } from "@/store/braze-webhooks/braze-webhook.interface";
import Webhook from "@/store/braze-webhooks";
import SearchBar from "./SearchBar.vue";

interface UpdatedItemPayload {
  item: BrazeWebhookDto;
  index: number;
}

@Component({
  components: {
    "webhook-item": WebhookItem,
    "search-bar": SearchBar
  }
})
export default class AppWebhookItem extends Vue {
  page: number = 1;
  data: BrazeWebhookDto[] = [];
  query: string = "";
  async infiniteHandler($state: any) {
    this.search($state);
  }

  async search($state: any) {
    try {
      const res = await Webhook.api().fetch({
        params: {
          page: this.page,
          keywords: this.query,
          order: "id||DESC"
        }
      });

      const webhooks = res.response.data.data;

      if (webhooks.length) {
        this.data.push(...webhooks);
        this.page += 1;
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    } catch (error) {}
  }

  async onSearch(query: string) {
    this.page = 1;
    this.data = [];
    this.query = query;
    this.search(null);
  }

  mounted() {
    this.sockets.subscribe("webhookAdded", (data: any) => {
      this.onSearch(this.query);
    });
  }

  destroyed() {
    this.sockets.unsubscribe("webhookAdded");
  }

  onUpdatedItem(input: UpdatedItemPayload) {
    this.data = [
      ...this.data.slice(0, input.index),
      {
        ...(input.item as any)
      },
      ...this.data.slice(input.index + 1, this.data.length)
    ];
  }

  async goTo(item: BrazeWebhookDto) {
    this.$router.push("/braze-webhooks/" + item.id);
  }
}
